export function DocumentsLoadingState() {
  return (
    <div data-testid="documents-loading-state" className="flex min-h-screen items-center justify-center bg-background">
      <div className="h-12 w-12 animate-spin rounded-full border-2 border-white/20 border-t-white" />
    </div>
  );
}
